export const handleValidadeError = (msgError: string) => {
    switch (msgError) {
        case 'Não conseguimos encontrar o veiculo, por favor nos informe os dados.':
            return true;
        case 'excecao_fallback_integracao_infocar':
            return true;
        case 'Consulta Infocar Desativada':
            return true;
        default:
            return false;
    }
}

export const vehicleTypeMismatchMessage = 'O tipo do veículo não é compatível com a placa informada. Por favor, revise os dados e tente novamente.';

export const isVehicleTypeMismatchMessage = (msgError: string) => msgError === 'tipo_veiculo_incorreto';